import type { Practitioner, Reference } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'

export abstract class Subscribeable extends ExtendedResource {
  subscribers: Reference<Practitioner>[] = []
  addSubscriber(subscriber: Reference<Practitioner>): void {
    this.subscribers.push(subscriber)
  }
  removeSubscriber(subscriber: Reference<Practitioner>): void {
    this.subscribers = this.subscribers.filter(
      (s) => s.reference !== subscriber.reference
    )
  }
  isSubscriber(practitioner: Reference<Practitioner>): boolean {
    return this.subscribers.some((s) => s.reference === practitioner.reference)
  }
}

export function isSubscribeable(resource: any): resource is Subscribeable {
  return (
    typeof resource?.isSubscriber === 'function' &&
    typeof resource?.addSubscriber === 'function' &&
    typeof resource?.removeSubscriber === 'function'
  )
}
